import React from 'react';
import Ac from './AcApp';
import 'bootstrap/dist/css/bootstrap.min.css';

function App() {
  return (
    <div className="App">
      <Ac />
    </div>
  );
}

export default App;
